import { Loader2 } from 'lucide-react';
import { Card } from './Card';

export function LoadingState({ message = 'Loading…' }: { message?: string }) {
  return (
    <Card>
      <div className="flex items-center gap-3 py-4 justify-center">
        <Loader2 size={16} className="animate-spin text-primary" />
        <p className="text-small text-ink-subtle">{message}</p>
      </div>
    </Card>
  );
}
